import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createI18n, setLocaleData } from '@wordpress/i18n'; 
import { I18nProvider } from '@wordpress/react-i18n';
import { addLocale, PrimeReactProvider } from 'primereact/api';
import './assets/scss/theme.scss';

// routes
import Routes from './routes';

// store
import { storeSet, useStoreActions } from './store';



const i18n = createI18n({}, 'gepafin');

function App() {
    const { setAsyncRequest, unsetAsyncRequest, doLogout } = useStoreActions();
    const value = {
        locale: 'it',
    };

    // eslint-disable-next-line no-unused-vars
    const callback = (data) => {
        if (data.status === 'SUCCESS') {
            storeSet('userData',data.data);
        } else {
           
            doLogout();
        }
        unsetAsyncRequest();
    }

    // eslint-disable-next-line no-unused-vars
    const errCallback = (data) => {
        unsetAsyncRequest();
    }

    useEffect(() => {
        setAsyncRequest();
        // AuthenticationService.me(callback, errCallback);

        addLocale('it', {
            startsWith: 'Inizia con',
            contains: 'Contiene',
            notContains: 'Non contiene',
            endsWith: 'Finisce con',
            equals: 'Uguale a',
            notEquals: 'Diverso da',
            noFilter: 'Nessun filtro',
            lt: 'Minore di',
            lte: 'Minore o uguale a',
            gt: 'Maggiore di',
            gte: 'Maggiore o uguale a',
            dateIs: 'Data uguale a',
            dateIsNot: 'Data diversa da',
            dateBefore: 'Data prima di',
            dateAfter: 'Data dopo',
            custom: 'Personalizzato',
            clear: 'Cancella',
            apply: 'Applica',
            matchAll: 'Tutte le condizioni',
            matchAny: 'Qualsiasi condizione',
            addRule: 'Aggiungi regola',
            removeRule: 'Rimuovi regola',
            accept: 'Sì',
            reject: 'No',
            choose: 'Scegli',
            upload: 'Carica',
            cancel: 'Annulla',
            dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
            dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
            dayNamesMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
            monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
            monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
            today: 'Oggi',
            weekHeader: 'Sm',
            firstDayOfWeek: 1,
            dateFormat: 'dd/mm/yy',
            weak: 'Debole',
            medium: 'Medio',
            strong: 'Forte',
            passwordPrompt: 'Inserisci una password',
            emptyMessage: 'Nessun risultato trovato',
            emptyFilterMessage: 'Nessun risultato trovato'
        });

        fetch('/languages/en_US.json')
            .then((res) => res.json())
            .then(res => {
                setLocaleData(res.locale_data['scan360'], 'scan360')
            })
    }, [setAsyncRequest, unsetAsyncRequest,doLogout]);

    return (
        <I18nProvider i18n={i18n}>
            <BrowserRouter>
                <PrimeReactProvider value={value}>
                    <Routes/>
                </PrimeReactProvider>
            </BrowserRouter>
        </I18nProvider>
    );
}

export default App;
